import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-filter-panel-wrapper',
  standalone: true,
  imports: [],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="ignite-filter-panel">
      <div class="filter-header">
        <h3>Filters</h3>
      </div>

      <div class="filter-grid">
        <ng-content></ng-content>
      </div>

      <div class="filter-actions">
        <button class="clear-filters-btn" (click)="onClearFilters()">
          Clear All Filters
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .ignite-filter-panel {
        padding: 0;
        margin-top: 0;
        margin-bottom: 16px;
      }

      .filter-header {
        margin-bottom: 8px;
      }

      .filter-header h3 {
        font-size: 0.875rem;
        font-weight: 500;
        color: #374151;
        margin: 0;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }

      .filter-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 12px;
        margin-bottom: 8px;
      }

      .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .filter-field label {
        font-size: 12px;
        font-weight: 500;
        color: #6b7280;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }

      .filter-select,
      .filter-input {
        width: 100%;
        padding: 6px 8px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        background: white;
        color: #1a1a2e;
        font-size: 14px;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
        cursor: pointer;
        box-sizing: border-box;
      }

      .filter-select:hover,
      .filter-input:hover {
        border-color: #9ca3af;
      }

      .filter-select:focus,
      .filter-input:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
      }

      .filter-actions {
        display: flex;
        justify-content: flex-end;
      }

      .clear-filters-btn {
        padding: 4px 10px;
        border: none;
        background: transparent;
        color: #13352c;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
        transition: all 0.2s;
      }

      .clear-filters-btn:hover {
        background: #f0fffe;
      }
    `,
  ],
})
export class FilterPanelWrapperComponent {
  @Output() clearFilters = new EventEmitter<void>();

  onClearFilters(): void {
    this.clearFilters.emit();
  }
}
